import request from '@/utils/request'

export function getMenu() {
  return request({
    url: '/api/home/sys/menutree/getmenutree',
    method: 'get'
  })
}

export function saveMenuMe(menuId) {
  return request({
    url: '/api/home/sys/menutree/savemenume',
    method: 'post',
    data: {
      menuId: menuId
    }
  })
}

export function delMenuMe(menuId) {
  return request({
    url: '/api/home/sys/menutree/delmenume',
    method: 'post',
    data: {
      menuId: menuId
    }
  })
}

export function getHeaderBars() {
  return request({
    url: '/api/home/sys/headerbar/getheaderbars',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/menu.js